module.exports = __webpack_public_path__ + "img/142.fd7913ca.jpg";